module.exports = __webpack_public_path__ + "img/icon_map_jght_c.4adc469a.png";